<template>
    <div>
      <Tables ref="tableGridsTemplateLV"
                  :columns= columTemplate
                  :showSearch="false"
                  :showPrint="false"
                  :newHeaderStatus="true"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoad"
                  style="font-family: 'Segoe UI'">
                  <tr v-for="(obj,index) in dataTemplateLV" :key="index">
                  <TableColumn
                  :IsTextGreen="true"
                  v-on:Edit="DetailsExpense(obj)"
                  :status="1"
                  :value="obj.itemAvaliacao != null ? obj.itemAvaliacao: 'N/D'" />
                  <TableColumn
                  :IsTextGreen="true"
                  v-on:Edit="DetailsExpense(obj)"
                  :status="1"
                  :value="obj.codigoTemplate != null ? obj.codigoTemplate: 'N/D'" />
                  <TableColumn
                  :IsTextOrange="obj.status === 2 ? true : false"
                  :IsTextDanger="obj.status === 0 ? true : false"
                  :IsTextGreeen="obj.status === 1 ? true : false"
                  v-on:Edit="DetailsExpense(obj)" :status="1" :value="obj.descricaoStatus != null ?  obj.descricaoStatus :  'N/D'" />
                  <TableColumn
                  :IsText="true"
                  v-on:Edit="DetailsExpense(obj)"
                  :status="1"
                  :value="obj.dataCriacao != null ? obj.dataCriacao: 'N/D'" />
                  <TableColumn
                  :IsInt="true"
                  v-on:Edit="DetailsExpense(obj)"
                  :status="1"
                  :value="obj.revisao != null ? obj.revisao : 'N/D'" />
                  <TableColumn
                  :IsViewExpenses="true"
                  :deletePopupTemplate="true"
                  :IsDisable="obj.statusTemplate === 1"
                  :IsActive="obj.statusTemplate === 0"
                  v-on:deleteTemplate="excluirTemplate(obj)"
                  v-on:DisableRegistration="desativarAtivar(obj.id)"
                  v-on:ActiveRegistration="desativarAtivar(obj.id)"
                  v-on:DetailsExpense="DetailsExpense(obj)"
                  v-on:Edit="abrirPopUpEditar(obj)"
                  />
                  </tr>
                  <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote-template-qma" @click="abrirPopUp">+ NOVO TEMPLATE</button>
                      <button class="btn-generate-lote-template-qma" @click="openFiles"><i class="far fa-file-excel"></i> IMPORTAR PLANILHA</button>
                      <input type="file"  v-on:change="imporTable" id="impor-ex-price" itemid="impor-ex">
                  </div>
                  </template>
      </Tables>
      <newTemplate ref="newtablelv" :tipoFluxo="tipoFluxo" @recarregarTable='onLoad'></newTemplate>
      <deleteTemplate ref="deletetablelv" :id="id" :template="template" @recarregarTable='onLoad'></deleteTemplate>
     </div>

</template>

<script>
import templateTable from './templateTable'
export default templateTable
</script>

    <style scoped>
  .icone-alerta {
    display: flex;
    margin: 1rem 0 1rem 0;
    justify-content: center;
    font-size: 55px;
    color: darkgreen;
  }
  .font-clone{
    display: flex;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
  #impor-ex-price{
    display: none;
  }
   .novoTemplate {
      padding: 0.5rem 3rem 0.5rem 3rem
   }
   .descricaoArea{
      width: 100%;
      height: 5rem;
      border-color: #b3b3b3;
      border-radius: 1px;
   }
   .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .btn-generate-lote-template-qma {
      height: 2rem;
      padding: 0 1rem;
      background: #008144;
      color: white;
      border-radius: 4px;
      width: 163px;
      border: none;
      font-size: 10px;
  }
  .btn-generate-lote-template-qma:hover{
      background: #024d2a;
      width: 163px;
  }
  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaTemplate/templateQmaLV/components/templateTable/templateTable.vue